import type { Product } from '../models';

export const getNonDiscontinuedAndCannotBeSold = (products: Product[]) =>
  products.filter((product) => !product.isDiscontinuedAndCannotBeSold);
